import {
  observable,
  action,
} from 'mobx';
import { Measurement } from '../constants/Configuration';
import logger from '../utils/logger';
import RootStore from './root-store';

export const API_KEY = 'af869e8fe211cd86687ab39b9e9445b5';
export const TEMP_UNITS = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
};

type TempUnits = typeof TEMP_UNITS[keyof typeof TEMP_UNITS];

class WeatherStore {
  rootStore: RootStore;
  @observable temperature: number|null = null;
  @observable humidity: number|null = null;
  @observable pressure: number|null = null;
  @observable city: string|null = null;
  @observable country: string|null = null;
  @observable tempUnits: TempUnits|null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  async getCurrentWeather(): Promise<any> {
    const { settingsStore } = this.rootStore;
    const { configuration } = settingsStore;
    //@ts-ignore
    const { latitude, longitude, measurement, locationName } = configuration;

    if (!locationName && !latitude) {
      return;
    }

    this.tempUnits =
      measurement === Measurement.Metric ? TEMP_UNITS.METRIC : TEMP_UNITS.IMPERIAL;

    const query = longitude ? `lat=${latitude}&lon=${longitude}` : `q=${locationName}`;
    const url = `https://api.openweathermap.org/data/2.5/weather?${query}&units=${this.tempUnits}&appid=${API_KEY}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      const { main, sys } = data;

      if (main && sys) {
        this.temperature = main.temp;
        this.humidity = main.humidity;
        this.pressure = main.pressure;
        this.city = data.name;
        this.country = sys.country;
      }

      return data;
    } catch (error) {
      logger.error('Can\'t fetch the weather data!', error);
    }
  }
}

export default WeatherStore;
